import { FUEL_TYPES } from '../constants/Publication';

type Transmission = 'Mecánica' | 'Automático';

export interface PlateVehicle {
    version_id: number | null;
    version_name: string | null;
    fuel?: string;
    transmission?: Transmission;
}

const plain = (value: unknown): string =>
    typeof value === 'string' ? value.trim().normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase() : '';

const FUEL_ALIASES: Record<string, string> = { gasolina: 'bencina', petroleo: 'diesel', hibrida: 'hibrido', electrica: 'electrico' };

// Un valor fuera de FUEL_TYPES se descarta: mejor que el usuario lo elija a que se publique un combustible inválido.
export const normalizeFuel = (name: unknown): string | undefined => {
    const raw = plain(name);
    const fuel = FUEL_ALIASES[raw] ?? raw;
    return FUEL_TYPES.includes(fuel) ? fuel : undefined;
};

export const normalizeTransmission = (name: unknown): Transmission | undefined => {
    const transmission = plain(name);
    if (transmission.startsWith('auto')) return 'Automático';
    if (transmission.startsWith('man') || transmission.startsWith('mec')) return 'Mecánica';
    return undefined;
};

// Desde el 29-09 plates/obtain devuelve version/fuel/transmission en vez de
// version_name/fuelTypeName/transmissionName; se leen los dos por compatibilidad.
export const readPlateVehicle = (payload: any): PlateVehicle => {
    const id = payload?.version_id;
    const rawName = payload?.version_name ?? payload?.version;
    const name = typeof rawName === 'string' ? rawName.trim() : '';
    // BO rechaza una versión con id y sin nombre: o van los dos o ninguno.
    const hasVersion = id !== null && id !== undefined && id !== '' && name !== '';

    return {
        version_id: hasVersion ? id : null,
        version_name: hasVersion ? name : null,
        fuel: normalizeFuel(payload?.fuelTypeName ?? payload?.fuel),
        transmission: normalizeTransmission(payload?.transmissionName ?? payload?.transmission),
    };
};
